module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/hallowen-5e0fdb57878786ea5185b1a59db05e49.svg";